import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import styles from './FavoriteIcon.module.scss';

export interface FavoriteIconProps {
  favorited?: boolean;
  size: string;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({
  favorited,
  size,
}) => {
  return (
    <Box
      element="span"
      data-testid="favourite-icon"
      className={styles.container}
    >
      <Box
        data-testid="for-testing"
        element="span"
        className={[
          styles.icon,
          styles.containerPadding,
          favorited && styles.favorited,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <Box
          element="span"
          className={[
            styles.imageWrapper,
            size === constants.SMALL && styles.small,
          ].join(' ')}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="29"
            viewBox="0 0 32 29"
            className={styles.image}
            data-testid={`favourite-icon-${favorited ? 'remove' : 'add'}`}
          >
            <path
              d="M26.2783 5.99937C25.6919 5.41079 24.9956 4.94389 24.2292 4.62534C23.4629 4.30678 22.6415 4.14282 21.812 4.14282C20.9824 4.14282 20.161 4.30678 19.3947 4.62534C18.6283 4.94389 17.9321 5.41079 17.3456 5.99937L16.1286 7.22032L14.9116 5.99937C13.727 4.81104 12.1204 4.14344 10.4452 4.14344C8.77004 4.14344 7.16346 4.81104 5.97892 5.99937C4.79438 7.18771 4.12891 8.79944 4.12891 10.48C4.12891 12.1606 4.79438 13.7723 5.97892 14.9606L7.19596 16.1816L16.1286 25.1428L25.0612 16.1816L26.2783 14.9606C26.865 14.3723 27.3304 13.6738 27.6479 12.905C27.9655 12.1362 28.1289 11.3122 28.1289 10.48C28.1289 9.64782 27.9655 8.82379 27.6479 8.05499C27.3304 7.28618 26.865 6.58768 26.2783 5.99937Z"
              className={styles.path}
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </Box>
      </Box>
    </Box>
  );
};
